import React, { useEffect, useState } from 'react';

export default function BlogListDynamic() {
  const [blogs, setBlogs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [expandedPostIDs, setExpandedPostIDs] = useState([]);

  useEffect(() => {
    const fetchBlogs = async () => {
      try {
        const response = await fetch('https://airhubmaster-stage.esim.place/api/BlogOutReach/GetBlogs_OutReach', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({}), // if API requires a payload, include it here, else send empty object
        });

        const text = await response.text();

        if (!text) {
          throw new Error('Empty response from API');
        }

        let data;
        try {
          data = JSON.parse(text);
        } catch (parseError) {
          throw new Error('Invalid JSON response: ' + parseError.message);
        }

        if (data.isSuccess) {
          setBlogs(data.data);
        } else {
          setError('Failed to fetch blogs: API returned failure');
        }
      } catch (err) {
        setError('Error fetching blogs: ' + err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchBlogs();
  }, []);

  const toggleExpand = (postRowID) => {
    setExpandedPostIDs((prev) =>
      prev.includes(postRowID)
        ? prev.filter((id) => id !== postRowID)
        : [...prev, postRowID]
    );
  };

  const formatDate = (dateStr) => {
    const options = { year: 'numeric', month: 'short', day: 'numeric' };
    return new Date(dateStr).toLocaleDateString(undefined, options);
  };

  if (loading) return <p className="text-center p-6">Loading blogs...</p>;
  if (error) return <p className="text-center p-6 text-red-600">{error}</p>;

  return (
    <div className="max-w-7xl mx-auto p-4 sm:p-6 lg:p-8">
      <h1 className="text-3xl font-extrabold text-gray-900 mb-8 text-center">
        Airhub eSIM Outreach Blogs
      </h1>
      <div className="grid gap-8 md:grid-cols-2 lg:grid-cols-3">
        {blogs.map((blog) => (
          <article
            key={blog.postRowID}
            className="flex flex-col rounded-lg shadow-lg border border-gray-200 bg-white overflow-hidden"
          >
            <div className="relative h-48 w-full overflow-hidden">
              <img
                src={`https://bloglogin.airhubapp.com/data/${blog.imgPath}`}
                alt={blog.title}
                className="object-cover w-full h-full transition-transform duration-300 hover:scale-105"
                loading="lazy"
              />
            </div>
            <div className="flex flex-col flex-grow p-6">
              <h2 className="text-xl font-semibold text-gray-900 mb-2 line-clamp-2">
                {blog.title}
              </h2>
              <p className="text-sm text-indigo-600 font-semibold uppercase tracking-wide mb-1">
                {blog.category.replace(/-/g, ' ')}
              </p>
              <p className="text-gray-700 flex-grow mb-4 line-clamp-3">
                {blog.description}
              </p>
              <div className="flex items-center text-sm text-gray-500 mb-4 space-x-4">
                <time dateTime={blog.publishDate}>
                  {formatDate(blog.publishDate)}
                </time>
                <span>&bull;</span>
                <span>By {blog.author}</span>
              </div>
              <button
                onClick={() => toggleExpand(blog.postRowID)}
                className="self-start text-indigo-600 hover:text-indigo-800 font-medium focus:outline-none focus:ring-2 focus:ring-indigo-500 rounded"
                aria-expanded={expandedPostIDs.includes(blog.postRowID)}
                aria-controls={`post-content-${blog.postRowID}`}
              >
                {expandedPostIDs.includes(blog.postRowID) ? 'Show Less' : 'Read More'}
              </button>
              {expandedPostIDs.includes(blog.postRowID) && (
                <div
                  id={`post-content-${blog.postRowID}`}
                  className="mt-4 text-gray-800 prose max-w-none"
                  dangerouslySetInnerHTML={{ __html: blog.postContent }}
                />
              )}
            </div>
          </article>
        ))}
      </div>
    </div>
  );
}
